import React from "react";
import DashbardHeader from "../AdmissionFom/DashbardHeader";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import SHA512 from "crypto-js/sha512";
import { useSelector } from "react-redux";

export default function PaymentForm() {


  const student = useSelector((state) => state.auth.studentData);
  const [searchParams] = useSearchParams();
  const program = searchParams.get("program");
  const [hashValue, setHashValue] = useState();
  const [salt] = useState(process.env.REACT_APP_PAYU_SALT);
  const [key] = useState(process.env.REACT_APP_PAYU_KEY);
  const [txnid] = useState("txn_" + new Date().getTime());

  


useEffect(() => {
  if (!student?.name || !student?.email) return;

  const hashString = `${key}|${txnid}|50|${program}|${student.name}|${student.email}|||||||||||${salt}`;

  const hash = SHA512(hashString).toString();

  setHashValue(hash);

  setFormData({
    firstname: student.name,
    email: student.email,
    phone: student.phone_number,
    key,
    surl: "https://campus.acetians.in/api/v2/student/payment/success",
    furl: "https://campus.acetians.in/api/v2/student/payment/failed",
    hash: hash, 
    txnid,
    productinfo: program,
    lastname: "lastname",
  });

}, [student, key, salt, txnid,program]);



  const [formData, setFormData] = useState({
    firstname: student.name || "",
    email: student.email || "",
    phone: student.phone_number || "",
    key: key || "",
    surl: "https://gdclalitpur.ac.in/admission/student/payment/success",
    furl: "https://gdclalitpur.ac.in/admission/student/payment/failed",
    hash: hashValue,
    txnid: txnid,
    productinfo:program,
    lastname: "lastname",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();
  const backtodashboard = () => {
    navigate("/student/dashboard", { replace: true });
  };

  return (
    <>
      <div className="chalan-payment-container">
        <div className="chalan-payment-content">
          <h1 className="chalan-payment-title">Payment Form</h1>
{}
          <div className="chalan-payment-card">
            <div className="payment-page-view">
              <h4 onClick={()=>console.log(formData,student)}>-/₹50</h4>
              <Link to="/student/dashboard" className="cancle-pay">
                Cancel
              </Link>
            </div>
            <form
              method="post"
              action="https://secure.payu.in/_payment"
              className="chalan-payment-form"
            >
              {/* Name Field */}
              <div className="chalan-payment-field">
                <label htmlFor="name" className="chalan-payment-label">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="firstname"
                  value={student.name}
                  // onChange={handleInputChange}
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your full name"
                />
              </div>

              {/* Email Field */}
              <div className="chalan-payment-field">
                <label htmlFor="email" className="chalan-payment-label">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={student.email}
                  onChange={handleInputChange}
                  required
                  readOnly={true}
                  className="chalan-payment-input"
                  placeholder="Enter your email address"
                />
              </div>

              {/* Phone Field */}
              <div className="chalan-payment-field">
                <label htmlFor="phone" className="chalan-payment-label">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={student.phone_number}
                  onChange={handleInputChange}
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>

              <div
                className="chalan-payment-field-2"
                style={{ display: "none" }}
              >
                <label htmlFor="phone" className="chalan-payment-label">
                  Lastname *
                </label>
                <input
                  type="text"
                  id="lastname"
                  name="lastname"
                  value={"lastname"}
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>
              <div
                className="chalan-payment-field-2"
                style={{ display: "none" }}
              >
                <label htmlFor="phone" className="chalan-payment-label">
                  key*
                </label>
                <input
                  type="text"
                  id="key"
                  name="key"
                  value={key}
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>

              <div
                className="chalan-payment-field-2"
                style={{ display: "none" }}
              >
                <label htmlFor="phone" className="chalan-payment-label">
                  txnid*
                </label>
                <input
                  type="text"
                  id="txnid"
                  name="txnid"
                  value={txnid}
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>

              <div
                className="chalan-payment-field-2"
                style={{ display: "none" }}
              >
                <label htmlFor="phone" className="chalan-payment-label">
                  productinfo*
                </label>
                <input
                  type="text"
                  id="productinfo"
                  name="productinfo"
                  value={program}
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>

              <div className="chalan-payment-field" style={{ display: "none" }}>
                <label htmlFor="phone" className="chalan-payment-label">
                  Amount
                </label>
                <input
                  type="text"
                  id="amount"
                  name="amount"
                  value={"50"}
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>

              <div
                className="chalan-payment-field-2"
                style={{ display: "none" }}
              >
                <label htmlFor="phone" className="chalan-payment-label">
                  surl *
                </label>
                <input
                  type="text"
                  id="surl"
                  name="surl"
                  value={
                    "https://campus.acetians.in/api/v2/student/payment/success"
                  }
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>

              <div
                className="chalan-payment-field-2"
                style={{ display: "none" }}
              >
                <label htmlFor="phone" className="chalan-payment-label">
                  furl *
                </label>
                <input
                  type="text"
                  id="furl"
                  name="furl"
                  value={
                    "https://campus.acetians.in/api/v2/student/payment/failed"
                  }
                  required
                  className="chalan-payment-input"
                  placeholder="Enter your phone number"
                />
              </div>
              <div
                className="chalan-payment-field-2"
                style={{ display: "none" }}
              >
                <label htmlFor="phone" className="chalan-payment-label">
                  hash *
                </label>
                <input
                  type="text"
                  id="hash"
                  name="hash"
                  value={hashValue}
                  required
                  className="chalan-payment-input-"
                  placeholder="Enter your phone number"
                />
              </div>

             
              <div className="chalan-payment-button-container">
                <button type="submit" className="chalan-payment-button">
                  Pay Now
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
